<template>
  <header class="header">
    <nav
      class="navigation"
      :class="loggedIn ? 'loggedIn' : ''"
      role="navigation"
      v-if="!hideNavigation"
    >
      <a href="#" class="icon" v-if="loggedIn" @click.prevent="sidebar = true">
        <i-icon name="menu" />
      </a>
      <h1 class="route-name">
        {{ __($route.meta.label) || __("Home page") }}
      </h1>
      <a
        v-if="$route.name !== 'Dashboard'"
        href="#"
        class="icon back"
        @click.prevent="back"
      >
        <i-icon name="arrow" />
      </a>
    </nav>
    <div class="hello">{{ __("Hello") }} {{ userName }}</div>
    <p-building-select />
    
  </header>
  <p-vue-sidebar
    :position="sideBarPosition"
    class="sidebar--menu"
    :style="{
      padding: 0,
      maxWidth: '297px',
    }"
    v-model:visible="sidebar"
  >
    <p-menu :close="() => (sidebar = false)" />
  </p-vue-sidebar>
</template>

<script>
import { computed, ref } from "vue";

import { useRouter } from "vue-router";

import PMenu from "@/components/partials/p-menu";
import PBuildingSelect from "@/components/partials/p-building-select";
import { mapState, useStore } from "vuex";

export default {
  components: {
    PMenu,
    PBuildingSelect,
  },
  computed: {
    ...mapState({
      loggedIn: (state) => state.api.loggedIn,
      showCheckList: (state) => state.showCheckList,
      financialReportMode: (state) => state.financialReportMode,
      userName: (state) => state.api.User.userName,
      hideNavigation: (state) => state.api.hideNavigation,

    }),
  },
  methods: {
    back() {
      if (
        this.$route.name == "FinancialReport" &&
        this.financialReportMode != "list"
      )
        this.setFinancialReportMode();
      else if (this.$route.name != "ServiceCalls" || !this.showCheckList)
        this.$router.go(-1);
      else this.$store.commit("setShowCheckList", false);
    },
    setFinancialReportMode() {
      let mode = "";
      if (this.financialReportMode == "cc-tran") mode = "payment-total";
      else if (this.financialReportMode == "payment-total") mode = "details";
      else if (this.financialReportMode == "details") mode = "list";

      this.$store.commit("setFinancialReportMode", mode);
    },
  },
  setup() {
    const $router = useRouter();
    const $store = useStore();
    const sidebar = ref(false);
    const sideBarPosition = computed(() => {
      return $store.getters.getLocal.dir === "rtl" ? "right" : "left";
    });
    $router.beforeEach(() => {
      sidebar.value = false;
    });

    return {
      sidebar,
      sideBarPosition,
    };
  },
};
</script>

<style scoped>
.sidebar--menu {
  padding: 0;
}

.header {
  top: 0;
  z-index: 100;
  position: sticky;
  position: -webkit-sticky;

  display: flex;
  flex-direction: column;

  background-color: var(--color-accent);
}

.header::before {
  content: "";

  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;

  pointer-events: none;
}

.header::before {
  z-index: 1;

  background-size: auto;
  background-repeat: no-repeat;
  background-position: top center;
  background-image: url("../../assets/img/banners/header.png");
}

.navigation {
  z-index: 2;
  position: relative;

  gap: 10px;
  display: grid;
  align-items: center;
  justify-content: space-between;
  grid-template-columns: auto 35px;

  padding: 15px;
}
.navigation.loggedIn {
  grid-template-columns: 35px auto 35px;
}

.route-name {
  margin: 0;

  color: white;
  line-height: 1;
  font-size: 26px;
  text-align: center;
  font-weight: normal;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;

  height: 35px;

  border-radius: 4px;
  border: 1px solid #89c4ff;

  color: white;
}

.icon:deep(.svg) {
  width: 20px;
  height: 20px;
}

.back:deep(.svg) {
  transform: rotate(-90deg);
}

.header:deep(.sidebar--menu) {
  width: 100%;
  max-width: 297px;

  padding: 0;
}

.header:deep(.p-dropdown) {
  z-index: 2;
  position: relative;

  background-color: #d2e0eed9;
}

.hello {
  font-size: 18px;
  letter-spacing: 0.51px;
  color: var(--color-accent);
  background-color: #fff;
  font-weight: 600;
  padding: 7px;
  text-align: center;
  border-bottom: 2px solid var(--color-accent);
}

@media screen and (min-width: 631px) {
  .header::before {
    background-size: cover;
  }
}
</style>
